import * as _ from 'lodash';

import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import * as DC from './dashboards.constants';
import ReducerCreator from '../registerReducer';
import { StoreItem } from '../Store';
import { Dashboard } from '../../models/';

const r = new ReducerCreator<Dashboard>()
    .register<Dashboard[]>(DC.DASHBOARDS_LOAD, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_LOAD_SUCCESS, (state, payload) => {
        return buildDashboardsStoreItem(payload);
    })
    // .register<Dashboard[]>(DASHBOARDS.DASHBOARD_ADD, (state, payload) => {
    //     let newState = buildDashboardsStoreItem(_.values(state.dictionary));
    //     newState.isLoaded = false;
    //     newState.isLoading = true;
    //     return newState;
    // })
    .register<Dashboard[]>(DC.DASHBOARDS_ADD, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_ADD_SUCCESS, (state, payload) => {
        return buildDashboardsStoreItem(payload);
    })
    .register<Dashboard[]>(DC.DASHBOARD_DELETE, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_DELETE, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard[]>(DC.DASHBOARD_DELETE_SUCCESS, (state, payload) => {
        return buildDashboardsStoreItem(payload);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_DELETE_SUCCESS, (state, payload) => {
        return buildDashboardsStoreItem(payload);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_UPDATE, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard[]>(DC.DASHBOARDS_UPDATE_SUCCESS, (state, payload) => {
        return buildDashboardsStoreItem(payload);
    })
    .register<Dashboard[]>(DC.DASHBOARD_UPDATE, (state, payload) => {
        return setLoading(state);
    })
    .register<Dashboard>(DC.DASHBOARD_UPDATE_SUCCESS, (state, payload) => {
        const newDic = {};
        for (const key of Object.keys(state.dictionary)) {
            newDic[key] = state.dictionary[key];
        }

        newDic[payload.guid] = payload;
        const result = (Object as any).assign({}, state, { dictionary: newDic });
        return result;
    })
    .register<string>(APPLICATION_DISCONNECTED, () => {
        const newState = new StoreItem<Dashboard>();
        return newState;
    });

function setLoading(state: StoreItem<Dashboard>) {
    const newState = buildDashboardsStoreItem(_.values(state.dictionary));
    newState.isLoaded = false;
    newState.isLoading = true;
    return newState;
}

function buildDashboardsStoreItem(payload: Dashboard[]) {
    const dic = {};
    payload.forEach(element => {
        dic[element.guid] = element;
    });
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

export function dashboardsReducer(state: StoreItem<Dashboard> = new StoreItem<Dashboard>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
